<!-- 由 suu 创建于 2022-01-19 星期三 -->
<template>
  <div class="ques-steps">
    <div class="previous user-btn" @click="preStep">
      <template v-if="curQuetionIndex">
        <van-icon name="arrow-left" />
        {{ current > 1 ? '上一题' : '返回' }}
      </template>
    </div>
    <div class="total">
      <div class="current" :style="{ width: percentage + '%' }"></div>
    </div>
    <div>{{ percentage }}%</div>
  </div>
</template>

<script>
export default {
  name: 'ques-steps',

  components: {},

  props: {
    current: {},
    curQuetionIndex: {},
    total: {}
  },

  data() {
    return {
      percentage: 0
    }
  },

  computed: {},

  watch: {
    // curQuetionIndex(nv) {
    //   console.log('====================================')
    //   console.log('当前目标下标', nv)
    //   console.log('====================================')
    // },
    current(nv) {
      this.percentage = this.computePercentage(nv, this.total)
    }
  },

  created() {
    this.percentage = this.computePercentage(this.current, this.total)
  },

  mounted() {},

  destroyed() {},

  methods: {
    preStep() {
      this.$emit('prestep')
    },
    computePercentage(current, total) {
      let percentage = parseFloat(((current / total) * 100).toFixed(1))
      return percentage || 0
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 750) * 100vw;
}
.ques-steps {
  width: 100%;
  box-sizing: border-box;
  padding: vw(18) vw(30);
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100vw;
  font-size: vw(30);
  color: #363d54;
  background-color: #f5f5f7;
  position: sticky;
  top: -1px;
  .previous {
    min-width: vw(100);
    font-size: 14px;
    font-weight: 500;
    line-height: 21px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .total {
    width: 222px;
    overflow: hidden;
    flex-shrink: 0;
    height: vw(32);
    position: relative;
    background-color: #fff;
    border-radius: vw(28);
  }
  .current {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
    height: 100%;
    transition: width 0.2s linear;
    background-color: #c9bbff;
  }
}
</style>
